import "@/views/Portal/Portal.scss";

import { Outlet } from "react-router-dom";

import { PartnerPortalHeader } from "@/apps/partner/components/PartnerPortalHeader/PartnerPortalHeader";
import { PartnerPortalSideMenu } from "@/apps/partner/components/PartnerPortalSideMenu/PartnerPortalSideMenu";
import { Background } from "@/components/Layout/Background/Background";
import { Footer } from "@/components/Layout/Footer/Footer";

const PartnerDashboard = () => {
  return (
    <Background>
      <PartnerPortalHeader />
      <main id="portal-wrapper">
        <PartnerPortalSideMenu />
        <Outlet />
      </main>
      <Footer className="has-wave" />
    </Background>
  );
};

export default PartnerDashboard;
